module.exports = __webpack_public_path__ + "public/SiteIcons/edit.png?6d8099f2";